var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 5.25H6.75C5.9175 5.25 5.25 5.925 5.25 6.75V17.25C5.25 18.075 5.9175 18.75 6.75 18.75H17.25C18.075 18.75 18.75 18.075 18.75 17.25V6.75C18.75 5.925 18.0825 5.25 17.25 5.25ZM17.25 17.25H6.75V8.25H17.25V17.25ZM13.125 12.75C13.125 13.3725 12.6225 13.875 12 13.875C11.3775 13.875 10.875 13.3725 10.875 12.75C10.875 12.1275 11.3775 11.625 12 11.625C12.6225 11.625 13.125 12.1275 13.125 12.75ZM12 9.75C9.9525 9.75 8.205 10.995 7.5 12.75C8.205 14.505 9.9525 15.75 12 15.75C14.0475 15.75 15.795 14.505 16.5 12.75C15.795 10.995 14.0475 9.75 12 9.75ZM12 14.625C10.965 14.625 10.125 13.785 10.125 12.75C10.125 11.715 10.965 10.875 12 10.875C13.035 10.875 13.875 11.715 13.875 12.75C13.875 13.785 13.035 14.625 12 14.625Z",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickView);
export default __webpack_public_path__ + "static/media/quick-view.be44be3d362f6ad141a0e31bb75707c8.svg";
export { ForwardRef as ReactComponent };